import deepmerge from "@node/deepmerge";

let locales = {};
const modules = import.meta.glob("@o-din-audit/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-audit/src/audit/store";
import menu from "@o-din-audit/src/audit/menu.json";

// Templates
import AuditTemplatesIndex from "@o-din-audit/src/views/audit/templates/Index.vue";
import AuditTemplatesForm from "@o-din-audit/src/views/audit/templates/Form.vue";
import AuditTemplatesShow from "@o-din-audit/src/views/audit/templates/Show.vue";
// Instanses
import AuditInstancesIndex from "@o-din-audit/src/views/audit/instances/Index.vue";
import AuditInstancesShow from "@o-din-audit/src/views/audit/instances/Show.vue";

export default {
  routes: [
    {
      path: '/audit/',
      component: { template: '<router-view></router-view>' },
      children: [
        { path: 'templates', component: () => import("./views/audit/templates/Index.vue") },
        { path: 'attempts', component: () => import("./views/audit/attempts/Index.vue") },
        { path: 'instances', component: () => import("./views/audit/instances/Index.vue") },
        { path: 'reports', component: () => import("./views/audit/attempts/ReportIndex.vue") },
      ]
    },
    { path: '/audit/templates/new', component: () => import("./views/audit/templates/Form.vue") },
    { path: '/audit/templates/:id/edit', component: () => import("./views/audit/templates/Form.vue") },
    { path: '/audit/templates/:id', component: () => import("./views/audit/templates/Show.vue") },
    // { path: '/audit/instances/new', component: () => import("./views/audit/instances/.vue") },
    { path: '/audit/instances/:id', component: () => import("./views/audit/instances/Show.vue") },

  ],
  locales,
  store,
  menu: [menu]
}
